import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/drob/ostrizen";

export const fetchShearedStatuses = createAsyncThunk(
  "shearedStatus/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const shearedStatusSlice = createSlice({
  name: "shearedStatus",
  initialState: {
    shearedStatuses: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShearedStatuses.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchShearedStatuses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.shearedStatuses = action.payload;
      })
      .addCase(fetchShearedStatuses.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default shearedStatusSlice.reducer;
